document.addEventListener("DOMContentLoaded", function() {
  const openModalButtons = document.querySelectorAll('.open-modal');
  const overlay = document.getElementById('modal-pbj-overlay');
  const modals = document.querySelectorAll('.modal-pbj');
  const closeModalButtons = document.querySelectorAll('.modal-pbj-close-button');
  let scrollPosition = 0;

  function closeModal() {
    const openModal = document.querySelector('.modal-pbj[style*="display: block"]');
    if (openModal) {
      document.body.classList.remove('fixed');
      document.body.style.top = '';
      window.scrollTo({
        top: scrollPosition,
        behavior: 'instant'
      });
      overlay.style.opacity = '0';
      openModal.style.opacity = '0';
      setTimeout(() => {
        overlay.style.display = 'none';
        openModal.style.display = 'none';
      }, 300);
    }
  }

  openModalButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const modalId = this.getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);
      scrollPosition = window.scrollY;
      document.body.style.top = `-${scrollPosition}px`;
      document.body.classList.add('fixed');
      overlay.style.display = 'block';
      modal.style.display = 'block';
      setTimeout(() => {
        overlay.style.opacity = '1';
        modal.style.opacity = '1';
      }, 10);
    });
  });

  closeModalButtons.forEach(button => {
    button.addEventListener('click', function() {
      closeModal();
    });
  });

  overlay.addEventListener('click', function() {
    closeModal();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
});
